import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import About from "./pages/About/About";
import Contact from "./pages/contact/Contact";
import Gallery from "./pages/Gallery/Gallery";
import CategoryPage from "./pages/categeory/CategoryPage"
import SubcategoryPage from "./pages/categeory/SubcategoryPage"
import Homepage from "./pages/Home/Homepage";


function App() {
  return (
    <Router>
      <div>
        <Routes>
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="/" element={<Homepage />} />

          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />

       
          <Route path="/category/:subcategory/:id" element={<CategoryPage />} />
          <Route path="/subcategory/:id/:itemId" element={<SubcategoryPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
